import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DropdownModule } from '../dropdown/dropdown.module';
import { ProjectsComponent } from './projects.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AddCostModule } from '../add-cost/add-cost.module';
import { ProjectInfoModalModule } from './project-info-modal/project-info-modal.module';
import { TranslateModule } from '@ngx-translate/core';
import { ActionMenuComponent } from '../action-menu/action-menu.component';
import { ActionMenuDirective } from '../action-menu/action-menu.directive';
import { OpsProjectStatusComponent } from '@ops/storybook';
import { DuplicateProjectModalComponent } from './duplicate-project-modal/duplicate-project-modal.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DropdownModule,
    AddCostModule,
    ProjectInfoModalModule,
    ActionMenuComponent,
    ActionMenuDirective,
    TranslateModule,
    OpsProjectStatusComponent,
    DuplicateProjectModalComponent,
  ],
  exports: [ProjectsComponent],
  declarations: [ProjectsComponent],
})
export class ProjectsModule {}
